import angular from 'angular';
import RetailerDashboardsSearchPageComponent from './retailer-dashboards-search-page-component';

export default angular.module('retailerDashboardsSearchPage', [])
  .component('retailerDashboardsSearchPage', new RetailerDashboardsSearchPageComponent())
;



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/containers/search-page/retailer-dashboards-search-page-module.js